import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-section sz-primary-red sz-white--text pt-10 pb-md-10 mb-5" }
const _hoisted_2 = { class: "text-h2 font-weight-medium text-center mb-8" }

import { THANKS_TUTORIAL } from '@/constants/tutorial';
import InfoSectionTiles from './InfoSectionTiles.vue';
import InfoSectionTutorial from './Tutorial/InfoSectionTutorial.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'InfoSectionThanks',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('home.infoSection.title')), 1),
                _createVNode(InfoSectionTiles, { class: "mt-4" }),
                _createVNode(InfoSectionTutorial, {
                  class: "mt-8",
                  "tutorial-tiles": _unref(THANKS_TUTORIAL)
                }, null, 8, ["tutorial-tiles"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})